export const daysWeek = {
  7: 'Domingo',
  1: 'Segunda-Feira',
  2: 'Terça-Feira',
  3: 'Quarta-Feira',
  4: 'Quinta-Feira',
  5: 'Sexta-Feira',
  6: 'Sábado',
}

export const cardBrandIcon = {
  Visa: {
    text: 'Visa',
    image: 'visa.svg',
  },
  Mastercard: {
    text: 'Mastercard',
    image: 'mastercard.svg',
  },
  Amex: {
    text: 'Amex',
    image: 'amex.svg',
  },
  Hipercard: {
    text: 'Hipercard',
    image: 'hipercard.svg',
  },
  Aura: {
    text: 'Aura',
    image: 'aura.svg',
  },
  Diners: {
    text: 'Diners',
    image: 'diners.svg',
  },
  Elo: {
    text: 'Elo',
    image: 'elo.svg',
  },
  JCB: {
    text: 'JCB',
    image: 'jcb.svg',
  },
  Discover: {
    text: 'Discover',
    image: 'discover.svg',
  },
  Banescard: {
    text: 'Banescard',
    image: 'banescard.svg',
  },
}

export const statusObjectProgressBar = {
  1: {
    code: 1,
    status: 'Aprovado',
    color: '#28c76f',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'success',
    lastProgressBarItemIcon: 'CheckCircleIcon',
    progressBarWidth: 100,
    size: 7,
  },
  2: {
    code: 2,
    status: 'Não Autorizado',
    color: '#ea5455',
    lastProgressBarItemText: 'Não Autorizado',
    lastProgressBarItemVariant: 'danger',
    lastProgressBarItemIcon: 'XCircleIcon',
    progressBarWidth: 100,
    size: 9,
  },
  3: {
    code: 3,
    status: 'Revisão',
    color: '#ff9f43',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'warning',
    lastProgressBarItemIcon: 'AlertCircleIcon',
    progressBarWidth: 63.5,
    size: 7,
  },
  5: {
    code: 5,
    status: 'Aguardando Pagamento',
    color: '',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'secondary',
    lastProgressBarItemIcon: 'CheckCircleIcon',
    progressBarWidth: 10,
    size: 6,
  },
  8: {
    code: 8,
    status: 'Falha na Recorrência',
    color: '#ea5455',
    lastProgressBarItemText: 'Não Autorizado',
    lastProgressBarItemVariant: 'danger',
    lastProgressBarItemIcon: 'XCircleIcon',
    progressBarWidth: 100,
    size: 9,
  },
  9: {
    code: 9,
    status: 'Criado',
    color: '#28c76f',
    lastProgressBarItemText: 'Criado',
    lastProgressBarItemVariant: 'success',
    lastProgressBarItemIcon: 'CheckCircleIcon',
    progressBarWidth: 100,
    size: 6,
  },
  10: {
    code: 10,
    status: 'Inativa',
    color: '#ea5455',
    lastProgressBarItemText: 'Inativa',
    lastProgressBarItemVariant: 'danger',
    lastProgressBarItemIcon: 'XIcon',
    progressBarWidth: 100,
    size: 7,
  },
  11: {
    code: 11,
    status: 'Aguardando Pagamento',
    color: '',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'secondary',
    lastProgressBarItemIcon: 'CheckCircleIcon',
    progressBarWidth: 10,
    size: 6,
  },
  12: {
    code: 12,
    status: 'Expirado',
    color: '#ff9f43',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'warning',
    lastProgressBarItemIcon: 'CheckCircleIcon',
    progressBarWidth: 10,
    size: 7,
  },
  13: {
    code: 13,
    status: 'Pago',
    color: '#28c76f',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'success',
    lastProgressBarItemIcon: 'CheckCircleIcon',
    progressBarWidth: 100,
    size: 7,
  },
  14: {
    code: 13,
    status: 'Baixado',
    color: '#ea5455',
    lastProgressBarItemText: 'Aprovado',
    lastProgressBarItemVariant: 'Danger',
    lastProgressBarItemIcon: 'XIcon',
    progressBarWidth: 25,
    size: 7,
  },
}

export const statusObject = {
  1: {
    code: 1,
    status: 'Aprovado',
    variant: 'success',
    icon: 'CheckCircleIcon',
    color: '#28c76f',
  },
  2: {
    code: 2,
    status: 'Não Autorizado',
    variant: 'danger',
    icon: 'XCircleIcon',
    color: '#ea5455',
  },
  3: {
    code: 3,
    status: 'Revisão',
    variant: 'warning',
    icon: 'AlertCircleIcon',
    color: '#ff9f43',
  },
  5: {
    code: 5,
    status: 'Aguardando Pagamento',
    variant: 'secondary',
    icon: 'ClockIcon',
    color: '',
  },
  8: {
    code: 8,
    status: 'Falha na Recorrência',
    variant: 'danger',
    icon: 'XCircleIcon',
    color: '#ea5455',
  },
  9: {
    code: 9,
    status: 'Criado',
    variant: 'success',
    icon: 'CheckCircleIcon',
    color: '#28c76f',
  },
  10: {
    code: 10,
    status: 'Inativa',
    variant: 'danger',
    icon: 'XCircleIcon',
    color: '#ea5455',
  },
  11: {
    code: 11,
    status: 'Aguardando Pagamento',
    variant: 'secondary',
    icon: 'ClockIcon',
    color: '',
  },
  12: {
    code: 12,
    status: 'Expirado',
    variant: 'warning',
    icon: 'XIcon',
    color: '#ff9f43',
  },
  13: {
    code: 13,
    status: 'Pago',
    variant: 'success',
    icon: 'CheckCircleIcon',
    color: '#28c76f',
  },
  14: {
    code: 14,
    status: 'Baixado',
    variant: 'danger',
    icon: 'XIcon',
    color: '#ea5455',
  },
}

export const statusObjectTimeLine = {
  1: {
    code: 1,
    status: 'Aprovado',
    variant: 'success',
    lastTimeLineIcon: 'CheckCircleIcon',
    subtitleText: 'Transação foi Aprovada',
  },
  2: {
    code: 2,
    status: 'Não Autorizado',
    variant: 'danger',
    lastTimeLineIcon: 'XCircleIcon',
    subtitleText: 'Transação foi Negada',
  },
  3: {
    code: 3,
    status: 'Revisão',
    variant: 'warning',
    lastTimeLineIcon: 'XCircleIcon',
    subtitleText: 'Transação está em Revisão',
  },
  8: {
    code: 8,
    status: 'Falha na Recorrência',
    variant: 'danger',
    lastTimeLineIcon: 'XCircleIcon',
    subtitleText: 'Recorrência foi Negada',
  },
  9: {
    code: 9,
    status: 'Criado',
    variant: 'success',
    lastTimeLineIcon: 'CheckCircleIcon',
    subtitleText: 'Recorrência foi Aprovada',
  },
  10: {
    code: 10,
    status: 'Inativa',
    variant: 'Danger',
    text_progress_bar: 'Inativa',
    lastTimeLineIcon: 'XIcon',
    subtitleText: 'Reconrrência foi Inativa',
  },
  11: {
    code: 11,
    status: 'Aguardando Pagamento',
    variant: 'secondary',
    lastTimeLineIcon: 'ClockIcon',
    subtitleText: 'Aguardando o cliente realizar o pagamento',
  },
  12: {
    code: 12,
    status: 'Expirado',
    variant: 'warning',
    text_progress_bar: 'Aprovado',
    lastTimeLineIcon: 'XIcon',
    subtitleText: 'Link foi expirado',
  },
  13: {
    code: 13,
    status: 'Pago',
    variant: 'success',
    text_progress_bar: 'Pago',
    lastTimeLineIcon: 'CheckCircleIcon',
    subtitleText: 'Pagamento efetuado com sucesso',
  },
  14: {
    code: 14,
    status: 'Estornado',
    variant: 'danger',
    text_progress_bar: 'Estornado',
    lastTimeLineIcon: 'XIcon',
    subtitleText: 'Boleto foi baixado',
  },
}